import NiceModal from '@ebay/nice-modal-react';

import { useEffect, useState } from 'react';

import Button from 'components/field/Button';
import FormItem from 'components/form/FormItem';

import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { IMPORT_EXPORT } from 'services/consts';

import AppLogger from 'utils/AppLogger';

import CustomOrdersForm from './CustomOrdersForm';

const CustomOrderImport = ({ setIsDisabled }) => {
	const axiosPrivate = useAxiosPrivate();
	const [data, setData] = useState(null);
	const [isLoading, setIsLoading] = useState(false);

	const getCustomImportData = async () => {
		try {
			setIsLoading(true);
			setIsDisabled?.(true);
			const response = await axiosPrivate.post(IMPORT_EXPORT.GET_CUSTOM_ORDER_TEMPLATE, {});
			if (response?.data && Object.keys(response?.data)?.length > 0) {
				setIsDisabled?.(false);
				setData(response.data);
			}
		} catch (error) {
			AppLogger.error('Error fetching custom import data:', error);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		getCustomImportData();
	}, []);

	const handleEditConfiguration = async () => {
		await NiceModal.show(CustomOrdersForm, {
			formData: data
		}).then((response) => {
			if (response?.status === true) {
				setIsDisabled?.(false);
			}
		});
	};

	return (
		<FormItem>
			<Button variant="outline" label="editConfiguration" onClick={handleEditConfiguration} loading={isLoading} />
		</FormItem>
	);
};

export default CustomOrderImport;
